import { useState, useMemo, createContext } from 'react';

interface TransactionSheet {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const TransactionSheetContext = createContext<TransactionSheet>({
  open: false,
  setOpen: () => {},
});

export default TransactionSheetContext;

export function TransactionSheetProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);

  // needed?
  const value: TransactionSheet = useMemo(
    () => ({ open, setOpen }),
    [open, setOpen]
  );

  return <TransactionSheetContext.Provider value={value}>
    {children}
  </TransactionSheetContext.Provider>;
}